export class CollaboratorTypeConstants {
  public static readonly DEVELOPER = "Developer";

  public static readonly VERIFIER = "Verifier";

  public static readonly STANDARD = "Standard";

  public static readonly DEVELOPMENT_MANAGER = "Development Manager";

  public static readonly RETAIL_AGGREGATOR = "Retail aggregator";

  public static readonly BUYER = "Buyer";

  public static readonly BROKER = "Broker";

  public static readonly INVESTOR = "Investor";

  public static readonly LANDOWNER = "Landowner";

  public static readonly TECHNOLOGY_PROVIDER = "Technology provider";

  public static readonly LOCAL_AUTHORITY = "Local authority";

  public static readonly GOVERNMENT = "Government";

  // Drives the "Company type" dropdown; the order is the one the form has always offered, not alphabetical.
  public static readonly ALL = [
    CollaboratorTypeConstants.DEVELOPER,
    CollaboratorTypeConstants.VERIFIER,
    CollaboratorTypeConstants.STANDARD,
    CollaboratorTypeConstants.DEVELOPMENT_MANAGER,
    CollaboratorTypeConstants.RETAIL_AGGREGATOR,
    CollaboratorTypeConstants.BUYER,
    CollaboratorTypeConstants.BROKER,
    CollaboratorTypeConstants.INVESTOR,
    CollaboratorTypeConstants.LANDOWNER,
    CollaboratorTypeConstants.TECHNOLOGY_PROVIDER,
    CollaboratorTypeConstants.LOCAL_AUTHORITY,
    CollaboratorTypeConstants.GOVERNMENT,
  ];

  /*
    The company types each transaction company field offers (BR-02829/02830). Lists rather than single values
    so widening a field later is an edit here alone — TransactionCompanyPicker filters and builds its tooltip
    from whatever it is given.
  */
  public static readonly COUNTERPARTY_TYPES = [CollaboratorTypeConstants.BUYER];

  public static readonly BROKER_TYPES = [CollaboratorTypeConstants.BROKER];
}
